/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getClaimablePayment} from '../api'

 export const useQueryGetClaimablePayment = createReactQueryHook('getClaimablePayment', getClaimablePayment)
